export { useTypeAheadData } from './useTypeAheadData';
